import moment from 'moment';
import Url from 'url-parse';
import companycontractstemplate from './contracts.tpl.html';
import { getCompanyById } from '../../../../reducers/companies';
import { getLoading } from '../../../../reducers/contracts';

export class CompanyContracts {
  constructor($scope, $ngRedux, actionsFactory, $translate, uploadService) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      uploadService,
      columns: [
        {
          type: 'button',
          id: 'warning',
          cssClass: 'tct-contract__warning-circle',
          width: '5%',
          isVisible: id => this.contractIsExpired(id),
        },
        {
          type: 'text',
          labelKey: 'TABLE_CONTRACT_NUMBER',
          id: 'contractNumber',
          width: '15%',
        },
        {
          type: 'text',
          id: 'validFrom',
          labelKey: 'TABLE_CONTRACT_VALID_FROM',
          width: '20%',
          transform: (column, element) => moment(element.validFrom, 'YYYY-MM-DD HH:mmZ').format('DD-MM-YYYY'),
        },
        {
          type: 'text',
          id: 'validUntil',
          labelKey: 'TABLE_CONTRACT_VALID_UNTIL',
          width: '20%',
          transform: (column, element) => moment(element.validUntil, 'YYYY-MM-DD HH:mmZ').format('DD-MM-YYYY'),
        },
        {
          type: 'text',
          id: 'credits',
          labelKey: 'TABLE_CONTRACT_CREDITS',
          width: '20%',
        },
        {
          type: 'link',
          id: 'contractUrl',
          width: '10%',
          cssClass: 'tct-icon tct-icon__download',
          href: id => this.downloadFile(id),
          target: '_blank',
          isVisible: id => this.documentIsNotNull(id),
        },
        {
          type: 'button',
          id: 'edit_contract',
          cssClass: 'tct-icon tct-icon__edit',
          width: '10%',
          onClick: id => this.showEditContractModal(id),
          isVisible: () => this.auth.user.type === 'editor' || false,
        },
      ],
    });
    const unsubscribe = $ngRedux.connect(CompanyContracts.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }

  static mapStateToThis(state) {
    return {
      auth: state.authentication,
      company: getCompanyById(state, state.router.currentParams.id),
      contracts: state.contracts.byId,
      loading: getLoading(state),
      router: state.router,
      priceList: state.priceList.defaultPriceList,
    };
  }

  $onInit() {
    this.reqCompanyContractsStart(this.router.currentParams.id);
    this.hasDefaultPriceList = true;
  }

  showEditContractModal(id) {
    this.contractId = id;
    this.showContractEdit = true;
    const contract = this.contracts[this.contractId];

    this.editContract = Object.assign({}, contract, {
      validFrom: moment(contract.validFrom, 'YYYY-MM-DD HH:mm:ssZZ').toDate(),
      validUntil: moment(contract.validUntil, 'YYYY-MM-DD HH:mm:ssZZ').toDate(),
    });
  }

  confirmEditContract() {
    this.showContractEdit = false;

    const validFrom = moment(this.editContract.validFrom)
      .startOf('day')
      .format('YYYY-MM-DD HH:mm:ssZZ');
    const validUntil = moment(this.editContract.validUntil)
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ssZZ');

    const data = {
      contract_number: this.editContract.contractNumber,
      valid_from: validFrom,
      valid_until: validUntil,
      contract_url: this.editContract.contractUrl,
      credits: this.editContract.credits,
    };

    this.updateContractStart(this.router.currentParams.id, this.contractId, data);
  }

  closeEditContractModal() {
    this.showContractEdit = false;
    this.editContract = {};
  }

  uploadFileOnCreate(event) {
    if (event.target.files && event.target.files[0]) {
      this.uploadFile(event.target.files[0])
        .then((fileObj) => {
          this.newContract.contractUrl = fileObj.url; // TODO: remove
          // this.newContract.contractUrl = fileObj.url_private; // TODO: enable
        });
    }
  }

  uploadFileOnUpdate(event) {
    if (event.target.files && event.target.files[0]) {
      this.uploadFile(event.target.files[0])
        .then((fileObj) => {
          this.editContract.contractUrl = fileObj.url; // TODO: remove
          // this.editContract.contractUrl = fileObj.url_private; // TODO: enable
        });
    }
  }

  /* eslint-disable */
  getFilenameFromUrl(url) {
    const urlObj = new Url(url);
    const lastIndexOfSlash = urlObj.pathname.lastIndexOf('/');
    return urlObj.pathname.substr(lastIndexOfSlash + 1);
  }
  /* eslint-enable */

  uploadFile(file) {
    return this.uploadService
      .uploadFile(file)
      .then(response => response.data.data);
  }

  documentIsNotNull(id) {
    if (!this.contracts[id].contractUrl) {
      return false;
    }

    return true;
  }

  contractIsExpired(id) {
    return moment(this.contracts[id].validUntil, 'YYYY-MM-DD HH:mm:ssZZ').isBefore(moment());
  }

  downloadFile(id) {
    return this.contracts[id].contractUrl;
  }

  showCreateContractModal() {
    this.reqPriceListDefaultStart();
    this.showContractCreate = true;
    this.newContract = {};
  }

  confirmCreateContract() {
    this.showContractCreate = false;

    const validFrom = moment(this.newContract.validFrom)
      .startOf('day')
      .format('YYYY-MM-DD HH:mm:ssZZ');
    const validUntil = moment(this.newContract.validUntil)
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ssZZ');

    const data = {
      contract_number: this.newContract.contractNumber,
      valid_from: validFrom,
      valid_until: validUntil,
      contract_url: this.newContract.contractUrl,
      credits: this.newContract.credits,
    };

    if (!this.hasDefaultPriceList) {
      data.price_entries = [];
      const priceList = [...this.priceList.list];
      const priceListData = Object.keys(this.priceList.data);
      for (let i = 0; i < priceListData.length; i += 1) {
        data.price_entries[i] = {};
        data.price_entries[i].product_type = priceListData[i];
        data.price_entries[i].price = priceList[i].price;
      }
    }

    this.createContractStart(this.router.currentParams.id, data);
    this.hasDefaultPriceList = true;
  }

  closeCreateContractModal() {
    this.showContractCreate = false;
    this.newContract = {};
    this.hasDefaultPriceList = true;
  }
}

CompanyContracts.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
  'uploadService',
];

export const companyContracts = {
  template: companycontractstemplate,
  controller: CompanyContracts,
};
